export default {"src":"/_next/static/media/Telegram.3dd93ec7.svg","height":37,"width":37,"blurWidth":0,"blurHeight":0};